import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Bygningsendring extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleBygningsendring = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var bygningsendring = this.props.bygningsendring
        var oppvarmingstyper = bygningsendring.oppvarmingstyper ? bygningsendring.oppvarmingstyper.map(o => o.oppvarmingsKode).join(', ') : '';
        var energikilder = bygningsendring.energikilder ? bygningsendring.energikilder.map(e => e.energikildeKode).join(', ') : '';

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleBygningsendring}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{bygningsendring.bygningsendringsKode}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{bygningsendring.kommunenavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bygningsnr')}</div>
                            <div className="value">{bygningsendring.bygningsnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bygningstype')}</div>
                            <div className="value">{bygningsendring.bygningstypeKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bygningsstatus')}</div>
                            <div className="value">{bygningsendring.bygningsstatusKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('sefrakminne')}</div>
                            <div className="value">{bygningsendring.harSefrakminne ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kulturminne')}</div>
                            <div className="value">{bygningsendring.harKulturminne ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('ufullstendigareal')}</div>
                            <div className="value">{bygningsendring.ufullstendigAreal ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksarealbolig')}</div>
                            <div className="value">{bygningsendring.bruksarealTilBolig}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruksarealannet')}</div>
                            <div className="value">{bygningsendring.bruksarealTilAnnet}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksarealtotalt')}</div>
                            <div className="value">{bygningsendring.bruksarealTotalt}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('alternativtareal')}</div>
                            <div className="value">{bygningsendring.alternativtAreal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('alternativtareal2')}</div>
                            <div className="value">{bygningsendring.alternativtAreal2}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruttoarealbolig')}</div>
                            <div className="value">{bygningsendring.bruttoarealTilBolig}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruttoarealannet')}</div>
                            <div className="value">{bygningsendring.bruttoarealTilAnnet}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruttoarealtotalt')}</div>
                            <div className="value">{bygningsendring.bruttoarealTotalt}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('antallbruksenheter')}</div>
                            <div className="value">{bygningsendring.antallBruksenheter}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('antallboenheter')}</div>
                            <div className="value">{bygningsendring.antallBoenheter}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bebygdareal')}</div>
                            <div className="value">{bygningsendring.bebygdAreal}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('harheis')}</div>
                            <div className="value">{bygningsendring.harHeis ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('vannforsyning')}</div>
                            <div className="value">{bygningsendring.vannforsyningsKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('avlop')}</div>
                            <div className="value">{bygningsendring.avlopsKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('energikilder')}</div>
                            <div className="value">{energikilder}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('oppvarmingstyper')}</div>
                            <div className="value">{oppvarmingstyper}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bygningsendringskode')}</div>
                            <div className="value">{bygningsendring.bygningsendringsKode}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Bygningsendring)